'use client';

import {useEffect} from 'react';
import {store, Venue} from '@/lib/UserFlow';

/**
 * Hydrates the xstate store with the server-resolved venue bundle on mount.
 * The venue layout is a server component that resolves the venue via Dashboard
 * (or short-circuits the `test` identifier); this client child plumbs the
 * resolved bundle into the global store so client triggers (NFC scan, language
 * filtering, message publish) can read it.
 */
export default function VenueHydrator({venue}: {venue: Venue}) {
  useEffect(() => {
    store.trigger.setVenue({venue});
  }, [venue]);

  return null;
}
